import React from 'react';
import { Box } from '@mui/material';
import logo from '../assets/logo.png';

function Logo({ height = 50 }) {
  return (
    <Box 
      component="img"
      src={logo}
      alt="Habitop Logo"
      sx={{
        height: height,
        width: 'auto',
        display: 'block'
      }}
    />
  );
}

export default Logo; 